// Shared by the provider-association modals so the new ones match InviteProviderModal.
export const MODAL_BACKDROP_CLASS =
  'fixed inset-0 bg-grey-100/60 backdrop-blur-sm transition-opacity data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in';

// No max-w here and no tailwind-merge in this app: each panel class below adds exactly one.
const MODAL_PANEL_BASE_CLASS =
  'relative w-full transform rounded-xl bg-white p-6 shadow-xl transition-all data-closed:translate-y-4 data-closed:opacity-0 data-enter:duration-300 data-enter:ease-out data-leave:duration-200 data-leave:ease-in data-closed:sm:translate-y-0 data-closed:sm:scale-95';

export const MODAL_PANEL_CLASS = `${MODAL_PANEL_BASE_CLASS} max-w-md`;

// [MCV-1929] The Add Provider form is wider from sm up so category and type sit side by side.
export const MODAL_PANEL_WIDE_CLASS = `${MODAL_PANEL_BASE_CLASS} max-w-md sm:max-w-2xl`;

export const MODAL_INPUT_CLASS =
  'mb-1 block w-full rounded-md border border-grey-800 bg-grey-950 p-3 text-sm placeholder:text-grey-700 transition-colors duration-150 focus:border-primary-50 focus:ring-3 focus:ring-primary-50/12 focus:outline-none';

// [MCV-1934] A native select is clickable while enabled. The global base rule in styles.css
// already says so; this keeps the dialog right even if that rule moves, and a utility outranks it.
export const MODAL_SELECT_CLASS = `${MODAL_INPUT_CLASS} enabled:cursor-pointer disabled:cursor-not-allowed`;

export const MODAL_LABEL_CLASS = 'mb-1 block text-sm font-medium text-content-primary';

export const MODAL_CLOSE_BTN_CLASS =
  'rounded-full p-1.5 text-grey-400 hover:text-grey-100 hover:bg-grey-900 transition-colors';

export const MODAL_LINK_BTN_CLASS =
  'cursor-pointer font-semibold text-primary-50 underline underline-offset-2';
